import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { SelectedThemeProvider, getThemeIdFromIrisContent } from '@spp/theme-provider';

import CoreNavigation from '@spp/ui-core-navigation';
import skin from '@vg/cn-skin-vg';
import Footer from '@vg/footer';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import whitelabelThemes from '@spp/roc-package-hyperion/app/theme/whitelabel';
import { PageOptions } from '@spp/ad-components';
import SkipToContent from '@spp/ui-skip-to-content';
import { cloneDeep, get, merge } from 'lodash';
import localThemes from '../../theme';
import BodyClass, { themePrefix } from '../../local-components/BodyClass';
import { getArticleAdKeywords } from '../../ads/helpers';
import shouldRedirectToMyPage from '../../utils/mypage-ab';

const engagement = ({ elementIdentifier, meta }) => {
    const { name, event } = meta;
    const href = event.target.pathname;

    try {
        const activity = window.AutoTrack.activity();
        const eventObj = activity.events.trackEngagement(
            undefined,
            undefined,
            'Click',
            'CoreNavigation',
            elementIdentifier,
            'Click',
            { name, targetUrl: href },
        );

        return new Promise((resolve) => eventObj.send(resolve));
    } catch (err) {
        console.error(err); // eslint-disable-line no-console
    }

    return Promise.resolve();
};

@connect((state) => ({
    article: state.article,
    device: state.device,
    irisStyles: state.themes,
}))
export default class App extends Component {
    static defaultProps = {
        children: [],
        article: {},
        device: 'desktop',
        irisStyles: {},
        location: {},
        isWeb: !!__WEB__, // to re-render some parts of the page in the browser
    };

    static propTypes = {
        children: PropTypes.node,
        article: PropTypes.shape({
            clientProperties: PropTypes.object,
        }),
        device: PropTypes.string,
        irisStyles: PropTypes.shape({
            default: PropTypes.object,
        }),
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
        isWeb: PropTypes.bool,
    };

    prepareCoreNavSkin = () => {
        if (this.props.isWeb) {
            const coreNavSkin = cloneDeep(skin);
            const replacement = {
                mastheadExtension: {
                    myPage: {
                        name: 'MyPage',
                    },
                },
            };
            if (shouldRedirectToMyPage(config.myPage.ratio)) {
                replacement.mastheadExtension.myPage.url = get(config, 'myPage.url');

                return merge(coreNavSkin, replacement);
            }
            replacement.mastheadExtension.myPage.url = `${
                coreNavSkin.mastheadExtension.myPage.url
            }?tag=mp_a`;

            return merge(coreNavSkin, replacement);
        }

        return skin;
    };

    render() {
        const { device, article, location: { pathname = '' } = {} } = this.props;
        const themeId = getThemeIdFromIrisContent(article);
        const { appnexus, smartAppBanner = {}, baseUrl, facebook = {} } = config;

        const appnexusArticleKeywords = getArticleAdKeywords(article, device);
        const appnexusKeywords = { ...appnexus.keywords, ...appnexusArticleKeywords };

        const skipToContentAnchors = [
            {
                href: '#main',
                anchorText: 'Hopp til hovedinnhold',
            },
        ];

        const smartAppBannerTags = smartAppBanner.tags.map(({ property, content }) => ({
            property,
            content: content.replace('{{LOCATION}}', baseUrl + pathname),
        }));

        return (
            <SelectedThemeProvider
                id={themeId}
                whitelabelThemesMapping={whitelabelThemes}
                localThemesMapping={localThemes}
                irisStyles={this.props.irisStyles}
            >
                <BodyClass theme={`${themePrefix}${themeId}`}>
                    <div className={'flex-container-column'}>
                        <Helmet
                            script={[
                                {
                                    innerHTML: `window.vgDevice = '${device}'`,
                                },
                            ]}
                        />
                        <Helmet meta={smartAppBannerTags} />
                        <Helmet meta={facebook.tags} />
                        <SkipToContent skipToContentAnchors={skipToContentAnchors} />
                        {device.indexOf('-app') === -1 && (
                            <CoreNavigation
                                skin={this.prepareCoreNavSkin()}
                                publicationName={'vg'}
                                sectionPath={pathname}
                                engagement={engagement}
                            />
                        )}
                        <PageOptions
                            member={appnexus.member}
                            disablePsa
                            noBidIfUnsold
                            keywords={appnexusKeywords}
                        />
                        {this.props.children}
                        <Footer />
                    </div>
                </BodyClass>
            </SelectedThemeProvider>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/app/index.js
 **/